import './Card.css';
export default {
    "card--contained": "Card_card--contained__j39oz",
    "card--stretched": "Card_card--stretched__j39oz",
    "contentWrapper": "Card_contentWrapper__j39oz",
    "body": "Card_body__j39oz",
    "title": "Card_title__j39oz",
    "readMore": "Card_readMore__j39oz"
};
